import * as React from 'react';
import {Button, ContentBlock} from 'framework7-react';

/// Displays information about the Building.
///
/// Shows the name, address, description, and architect, as well as an image
/// of the building and an audio tour (if available).
export class BuildingDetail extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            playingAudio: false
        };
        this.audio = new Audio();
    }

    onClickAudio = (url) => {
        if (url === '') {
            return;
        }

        if (this.state.playingAudio) {
            this.audio.pause();
            this.setState(prevState => ({playingAudio: false}));
        } else {
            this.audio.src = url;
            this.audio.play();
            this.setState(prevState => ({playingAudio: true}));
        }
    };

    componentWillReceiveProps(nextProps) {
        if (this.state.playingAudio && !nextProps.isVisible) {
            this.audio.pause();
        }
    }

    render() {
        let playClassName = 'active audio-button';
        let playText = 'Listen';
        let playIcon = 'play_fill';
        if (this.props.building.audio === '') {
            playClassName += ' disabled color-gray';
            playText = 'No audio available';
            playIcon = ''
        } else {
            if (this.state.playingAudio) {
                playIcon = 'pause_fill';
            }
            if (this.state.playingAudio) {
                playClassName += ' color-green';
                playText = 'Pause';
            }
        }

        const architectDisplay = this.props.building.architect === '' ? 'none': '';
        return (
            <ContentBlock className="building-detail-content">
                <h3 className="building-header">{this.props.building.name}</h3>
                <p>{this.props.building.address}</p>
                <p style={{display: architectDisplay}}>
                    Architect: <span dangerouslySetInnerHTML={{
                            __html: this.props.building.architectName
                        }}></span>
                </p>
                <div className="building-detail-image" style={{
                    backgroundImage: `url(${this.props.building.image})`
                }}/>
              	<Button className={playClassName} onClick={(event) => this.onClickAudio(this.props.building.audio)}>
                    <i className="icon f7-icons play-icon">{playIcon}</i>
                    {playText}
                </Button>
                <div className="building-description" dangerouslySetInnerHTML={{
                    __html: this.props.building.description
                }}></div>
                <a href="#" className="close-popup">Close</a>
                <i className="close-popup building-detail-upper-close f7-icons ">close_round</i>
            </ContentBlock>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/BuildingDetail.jsx